import React, { Component } from 'react';
import {Layout, Menu} from "antd";
import {Link} from "react-router-dom";
import createHistory from "history/createBrowserHistory";
import './header.css';


const { Header } = Layout;
const { SubMenu } = Menu;

export default class HeaderNav extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
        this.state={
            menuList:JSON.parse(window.localStorage.getItem('menuList'))
        }
    }
    componentDidMount() {
        // let that = this;
        // let userType  = window.localStorage.getItem('userType')
        // let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
        // if(userType==='external' && userInfo){
        //     getUserType(userInfo.requestorEmail).then(res=>{
        //     // getUserType('T1D_ADMIN_DK_AUTHORIZED@DUMMY.COM').then(res=>{
        //         const {data} = res;
        //         if(data){
        //             if(data.region==='WE'){
        //                 that.setState({menuList:WEMenuJson})
        //                 window.localStorage.setItem('menuList',JSON.stringify(WEMenuJson));
        //             }else{
        //                 that.setState({menuList:EMMenuJson})
        //             }
        //         }
        //     })
        // }
        // window.addEventListener("setItemEvent", function (e) {
        //     let item = JSON.parse(window.localStorage.getItem('menuList'));
        //     let userType  = window.localStorage.getItem('userType')
        //     if(userType === 'internal') {
        //         if (item) {
        //             that.setState({menuList: item})
        //         }
        //     }

        // });
    }

    render() {
        let {menuList} = this.state
        return <Header className="header">
            <Menu mode="horizontal" defaultSelectedKeys={[this.props.parmas]}>
                {
                    menuList && Object.keys(menuList).map((key) => (
                        <SubMenu key={menuList[key].name} title={menuList[key].name}>
                            {menuList[key].childMenuList.map((item) => (
                                <Menu.Item key={item.frontRouter}>
                                <span>{item.name}</span>
                                <Link to={{pathname: item.frontRouter}}></Link>
                                </Menu.Item>
                            ))}
                        </SubMenu>
                    ))
                }
                {/*    <SubMenu key="New Dispute" title="New Dispute">*/}
                {/*    <Menu.Item key="/wepcgcustomers">*/}
                {/*        <span>WE - PCG</span>*/}
                {/*        <Link to={{pathname: '/wepcgcustomers'}}></Link>*/}
                {/*    </Menu.Item>*/}
            {/*        <Menu.Item key="/wedcgcustomers">*/}
            {/*            <span>WE - DCG</span>*/}
            {/*            <Link to={{pathname: '/wedcgcustomers'}}></Link>*/}
            {/*        </Menu.Item>*/}
            {/*        <Menu.Item key="/empcgcustomers">*/}
            {/*            <span>EM - PCG</span>*/}
            {/*            <Link to={{pathname: '/empcgcustomers'}}></Link>*/}
            {/*        </Menu.Item>*/}
            {/*        <Menu.Item key="/emdcgcustomers">*/}
            {/*            <span>EM - DCG</span>*/}
            {/*            <Link to={{pathname: '/emdcgcustomers'}}></Link>*/}
            {/*        </Menu.Item>*/}
            {/*    </SubMenu>*/}
            {/*    <SubMenu key="Financial Claim" title="Financial Claim">*/}
            {/*        /!*<Menu.Item key="/singleCreateFinancialClaim">*!/*/}
            {/*        /!*    <span>Create Req. Single</span>*!/*/}
            {/*        /!*    <Link to={{pathname: '/singleCreateFinancialClaim'}}></Link>*!/*/}
            {/*        /!*</Menu.Item>*!/*/}
            {/*        <Menu.Item key="/singleFinancialClaimSearch">*/}
            {/*            <span>Claim Req – Edit</span>*/}
            {/*            <Link to={{pathname: '/singleFinancialClaimSearch'}}></Link>*/}
            {/*        </Menu.Item>*/}
            {/*        /!*<Menu.Item key="/CBSOCreateFinancialClaim">*!/*/}
            {/*        /!*    <span>CBSO - Single</span>*!/*/}
            {/*        /!*    <Link to={{pathname: '/CBSOCreateFinancialClaim'}}></Link>*!/*/}
            {/*        /!*</Menu.Item>*!/*/}
            {/*        <Menu.Item key="/CBSOFinancialClaimSearch">*/}
            {/*            <span>CBSO - Edit</span>*/}
            {/*            <Link to={{pathname: '/CBSOFinancialClaimSearch'}}></Link>*/}
            {/*        </Menu.Item>*/}
            {/*        <Menu.Item key="/financialClaimMassUpload">*/}
            {/*            <span>Claim Req - Mass</span>*/}
            {/*            <Link to={{pathname: '/financialClaimMassUpload'}}></Link>*/}
            {/*        </Menu.Item>*/}
            {/*        <Menu.Item key="/CBSOMassUpload">*/}
            {/*            <span>CBSO - Mass</span>*/}
            {/*            <Link to={{pathname: '/CBSOMassUpload'}}></Link>*/}
            {/*        </Menu.Item>*/}
            {/*        /!*<Menu.Item key="/CBSOSingle">*!/*/}
            {/*        /!*    <span>CBSO - Single</span>*!/*/}
            {/*        /!*    <Link to={{pathname: '/emdcgcustomers'}}></Link>*!/*/}
            {/*        /!*</Menu.Item>*!/*/}
            {/*        /!*<Menu.Item key="/CBSOMass">*!/*/}
            {/*        /!*    <span>CBSO - Mass</span>*!/*/}
            {/*        /!*    <Link to={{pathname: '/emdcgcustomers'}}></Link>*!/*/}
            {/*        /!*</Menu.Item>*!/*/}
            {/*        /!*<Menu.Item key="/CBSOEdit">*!/*/}
            {/*        /!*    <span>CBSO - Edit</span>*!/*/}
            {/*        /!*    <Link to={{pathname: '/emdcgcustomers'}}></Link>*!/*/}
            {/*        /!*</Menu.Item>*!/*/}
            {/*    </SubMenu>*/}
            {/*    <SubMenu key="Approval Center" title="Approval Center">*/}
            {/*        <Menu.Item key="/disputeApproval">*/}
            {/*            <span>Dispute Approval</span>*/}
            {/*            <Link to={{pathname: '/disputeApproval'}}></Link>*/}
            {/*        </Menu.Item>*/}
            {/*        <Menu.Item key="/finClaimApproval">*/}
            {/*            <span>FIN Claim Approval</span>*/}
            {/*            <Link to={{pathname: '/finClaimApproval'}}></Link>*/}
            {/*        </Menu.Item>*/}
            {/*        <Menu.Item key="/CBSOClaimApproval">*/}
            {/*            <span>CBSO Claim Approval</span>*/}
            {/*            <Link to={{pathname: '/CBSOClaimApproval'}}></Link>*/}
            {/*        </Menu.Item>*/}
            {/*    </SubMenu>*/}
            {/*    <SubMenu key="Status Report" title="Status Report">*/}
            {/*        <Menu.Item key="/disputeReport">*/}
            {/*            <span>Dispute Report</span>*/}
            {/*            <Link to={{pathname: '/disputeReport'}}></Link>*/}
            {/*        </Menu.Item>*/}
            {/*        <Menu.Item key="/claimReport">*/}
            {/*            <span>Financial Claim Report</span>*/}
            {/*            <Link to={{pathname: '/claimReport'}}></Link>*/}
            {/*        </Menu.Item>*/}
            {/*        <Menu.Item key="/CBSOClaimReport">*/}
            {/*            <span>CBSO Claim Report</span>*/}
            {/*            <Link to={{pathname: '/CBSOClaimReport'}}></Link>*/}
            {/*        </Menu.Item>*/}
            {/*    </SubMenu>*/}
            {/*    <Menu.Item key="/materials" value={4}>*/}
            {/*        <span>Contact us</span>*/}
            {/*        <Link to='/materials'></Link>*/}
            {/*    </Menu.Item>*/}
            {/*    <Menu.Item key="/faq" value={5}>*/}
            {/*        <span>FAQ & Manual</span>*/}
            {/*        <Link to='/faq'></Link>*/}
            {/*    </Menu.Item>*/}
            {/*    <Menu.Item key="/support" value={6}>*/}
            {/*        <span>Support</span>*/}
            {/*        <Link to='/support'></Link>*/}
            {/*    </Menu.Item>*/}
            </Menu>
        </Header>
    }
}
